<template>
    <div class="card fluid">  
                                    
        <div class="field grid removeConnectorGrid">
            <div class="col-12">
                <Button v-if="!isMinisterstvo" :label="translated('removeconnbutton')" class="p-button-raised p-button-warning removeConnector p-button-sm" icon="pi pi-trash" @click="removeConnector(conn)" />                       
            </div>                        
        </div>     

        <div class="field grid">
            <label class="col-12 md:col-5 mb-md-0">{{ translated('cableattached') }}</label>
            <div class="col-12 md:col-7">
                <Checkbox :disabled="isMinisterstvo" v-model="conn.CableAttached" :binary="true" />                        
            </div>                        
        </div>	

        <div class="field grid">
            <label class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.conn.MaxPowerAtSocket.$invalid && submitted}">{{ translated('maxpoweratsocket') }} *</label>
            <div class="col-12 md:col-7">
                <InputNumber :disabled="isMinisterstvo" v-model="conn.MaxPowerAtSocket" mode="decimal" :minFractionDigits="2" locale="sl-SI" :class="{'p-invalid':v$.conn.MaxPowerAtSocket.$invalid && submitted}"/>                				
            </div>                        
        </div>       

        <div class="field grid">
            <label class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.conn.CableType.$invalid && submitted}">{{ translated('cabletype') }} *</label>
            <div class="col-12 md:col-7">
                <Dropdown :disabled="isMinisterstvo" v-model="conn.CableType" :options="CableTypeAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectcabletype')" :class="{'p-invalid':v$.conn.CableType.$invalid && submitted}"/>					
            </div>                        
        </div>	 

        <div class="field grid">
            <label class="col-12 md:col-5 mb-md-0" :class="{'p-error': v$.conn.ChargingInterface.$invalid && submitted}">{{ translated('charginginterface') }} *</label>
            <div class="col-12 md:col-7">
                <Dropdown :disabled="isMinisterstvo" v-model="conn.ChargingInterface" :options="ChargingInterfaceAllOptions" optionLabel="label" optionValue="value" :placeholder="translated('selectcharginginterf')" :class="{'p-invalid':v$.conn.ChargingInterface.$invalid && submitted}" />					
            </div>                        
        </div>     

        <div class="field grid">
            <label class="col-12 md:col-5 mb-md-0">{{ translated('adhocpriceopt') }}</label>
            <div class="col-12 md:col-7">
                <InputNumber :disabled="isMinisterstvo" v-model="conn.AdHocPricePerDeliveryUnit" mode="decimal" :minFractionDigits="2" locale="sl-SI" />
            </div>                        
        </div>          
<!--
        <div class="field grid">
            <label class="col-12 md:col-5 mb-md-0">{{ translated('externalsystemid') }}</label>
            <div class="col-12 md:col-7">	
                <InputText class="btneditenabledExternalId" type="text" v-model="conn.ExternalSystemId" :disabled="!editenabledExternalId" />
                <Button v-if="editenabledExternalId" icon="pi pi-lock-open" class="p-button-rounded p-button-warning editenabledExternalId" @click="editenabledExternalId=false" />
                <Button v-if="!editenabledExternalId" icon="pi pi-lock" class="p-button-rounded p-button-warning editenabledExternalId" @click="editenabledExternalId=true" />
            </div>                        
        </div>	
        -->                  
    </div>   
</template>

<script>
import { email, required, between, numeric, minLength, maxLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { computed } from "vue";
import store from "@/store";

export default {
    setup: () => ({ v$: useVuelidate() }),
    props: ['conn','submitted'],
    emits: ['removeConnector'],
    //setup: () => ({ v$: useVuelidate() })
    data() {
        return {
            editenabledExternalId: false,
            translated: computed(() => store.getters.getTranslate),
            ChargingInterfaceAllOptions: [
                {label:"chademo", value:"chademo"},
                {label:"cee3", value:"cee3"},
                {label:"cee5", value:"cee5"},
                {label:"yazaki", value:"yazaki"},
                {label:"domestic", value:"domestic"},
                {label:"domesticA", value:"domesticA"},
                {label:"domesticB", value:"domesticB"},
                {label:"domesticC", value:"domesticC"},
                {label:"domesticD", value:"domesticD"},
                {label:"domesticE", value:"domesticE"},
                {label:"domesticF", value:"domesticF"},
                {label:"domesticG", value:"domesticG"},
                {label:"domesticH", value:"domesticH"},
                {label:"domesticI", value:"domesticI"},
                {label:"domesticJ", value:"domesticJ"},
                {label:"domesticK", value:"domesticK"},
                {label:"domesticL", value:"domesticL"},
                {label:"domesticM", value:"domesticM"},
                {label:"domesticN", value:"domesticN"},
                {label:"domesticO", value:"domesticO"},
                {label:"iec60309x2single16", value:"iec60309x2single16"},
                {label:"iec60309x2three16", value:"iec60309x2three16"},
                {label:"iec60309x2three32", value:"iec60309x2three32"},
                {label:"iec60309x2three64", value:"iec60309x2three64"},
                {label:"iec62196T1", value:"iec62196T1"},
                {label:"iec62196T1COMBO", value:"iec62196T1COMBO"},
                {label:"iec62196T2", value:"iec62196T2"},
                {label:"iec62196T2COMBO", value:"iec62196T2COMBO"},
                {label:"iec62196T3A", value:"iec62196T3A"},
                {label:"iec62196T3C", value:"iec62196T3C"},
                {label:"pantographBottomUp", value:"pantographBottomUp"},
                {label:"pantographTopDown", value:"pantographTopDown"},
                {label:"teslaConnectorEurope", value:"teslaConnectorEurope"},
                {label:"teslaConnectorAmerica", value:"teslaConnectorAmerica"},
                {label:"teslaR", value:"teslaR"},
                {label:"teslaS", value:"teslaS"},
                {label:"other", value:"other"}
            ],
            CableTypeAllOptions: [
                {label:"cableMode2", value:"cableMode2"},
                {label:"cableMode3", value:"cableMode3"},
                {label:"otherCable", value:"otherCable"},
                {label:"socket", value:"socket"}
            ]            
        }
    },
    validations() {
        let myvalidations = {
            conn: {			
                CableType: { required },
                ChargingInterface: { required },	
                MaxPowerAtSocket: { required }          
			} 
        };
        return myvalidations;
    },   
    mounted() {
        //console.log('KLIČEM MOUNTED Connector CONTROL !!!!')
        //console.log(this.submitted);
    },
    computed: {
		isMinisterstvo() {
            return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
            //return (this.$store.getters.getRole=="MAdmin" || this.$store.getters.getRole=="MUser");
			//return true;
        }
    },    
    methods: {
        removeConnector(tmpData) {
            //console.log(tmpData);
            this.$emit('removeConnector', {Id: tmpData.Id, DateAdded: tmpData.DateAdded})             
        },
    }
}
</script>

<style scoped>

.removeConnector {
    width: 150px;
    position:relative;
    float:right;
    top: 5px;
}
.grid.removeConnectorGrid {
    height: 0px;
    position: relative;
}

input.btneditenabledExternalId {
	width: calc( 100% - 50px );
}

button.editenabledExternalId {
	margin-left: 10px;
}
</style>